import moment from 'moment';
import { channelInfos } from './dictionary';
import { settlementTypes } from './dictionary/freight';

const filters = {
  formatLicense: function (str) {
    if (!str) return;
    return `${str.slice(0, 2)}·${str.slice(2)}`;
  },
  formatHours: function (time) {
    return moment(time).format('HH:mm');
  },
  formatDays: function (time) {
    if (time) {
      return moment(time).format('MM-DD');
    } else {
      return '';
    }
  },
  formatIsToday: function (time) {
    const REFERENCE = moment(); // fixed just for testing, use moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    const TOMORROW = REFERENCE.clone().add(1, 'days').startOf('day');

    function isToday(momentDate) {
      return momentDate.isSame(TODAY, 'd');
    }

    function isYesterday(momentDate) {
      return momentDate.isSame(YESTERDAY, 'd');
    }

    function isTomorrow(momentDate) {
      return momentDate.isSame(TOMORROW, 'd');
    }

    if (isToday(moment(time))) {
      return '今天';
    }
    if (isYesterday(moment(time))) {
      return '昨天';
    }
    if (isTomorrow(moment(time))) {
      return '明天';
    }
    return moment(time).format('M月D日');
  },
  formatIsCheck: function (time1) {
    return moment(time1).format('M月D日'); // fixed ;
  },
  formatTime(time) {
    return moment().isSame(time, 'day') ? '今天' : moment(time).format('M月D日');
  },
  formatEditTime: function (time) {
    if (time) {
      return moment(time).format('M月D日 HH:mm');
    }
  },
  formatPayType: function (type) {
    switch (type) {
      case 1:
        return '结算给司机';
      case 2:
        return '自定义';
      default:
        break;
    }
  },
  filterRemarks: function (remarks) {
    switch (remarks) {
      case 0 || '0':
        return '';
      case 1 || '1':
        return '风险运单';
      case 2 || '2':
        return '司机、车辆重复';
      case 3 || '3':
        return '装卸货地位置异常';
      case 4 || '4':
        return '运费过高';
      case 5 || '5':
        return '车辆为自有车';
      case 6 || '6':
        return '装货时间过早';
      default:
        break;
    }
  },
  filterTime: function (time) {
    if (time) {
      return moment(time).format('yyyy-MM-DD HH:mm:ss');
    }
  },
  statusFilter(waybillStatus) {
    if (waybillStatus === 'WAYBILL_WAIT') {
      return '待接单';
    }
    if (
      waybillStatus === 'INIT' ||
      waybillStatus === 'COMPLETE_INFO' ||
      waybillStatus === 'WAYBILL_PUSH'
    ) {
      return '待装货';
    }
    if (waybillStatus === 'WAYBILL_START') {
      return '运输中';
    }
    if (waybillStatus === 'WAYBILL_END') {
      return '已卸货';
    }
  },
  filterWaybillStatus: function (status) {
    switch (status) {
      case 'INIT':
        return '草稿';
      case 'WAYBILL_PUSH':
        return '待装货';
      case 'WAYBILL_START':
        return '运输中';
      case 'WAYBILL_END':
        return '已卸货';
      case 'TOCHECKED':
        return '待检查';
      case 'TOPUSHED':
        return '待推送';
      case 'UNDERREVIEW':
        return '审核中';
      case 'AUDITFAILED':
        return '审核不通过';
      case 'APPROVED':
        return '审核通过';
      default:
        break;
    }
  },
  filterWaybillApprovalStatus: function (status) {
    switch (status) {
      case '0':
      case 0:
        return '待审核';
      case 1:
      case '1':
        return '审核中';
      case 2:
      case '2':
        return '审核通过';
      case 3:
      case '3':
        return '审核拒绝';
      default:
        break;
    }
  },
  filterWaybillSource: function (source) {
    switch (source) {
      case 'WEB':
        return 'pc端开单';
      case 'ONE_STOP_WEB':
        return 'pc端开单';
      case 'WX_DISPATCH':
        return '调度端开单';
      case 'ONE_STOP_WX_DISPATCH':
        return '调度端开单';
      case 'WX_DRIVER':
        return '司机扫码';
      case 'ONE_STOP_WX_DRIVER':
        return '司机扫码';
      case 'EXCEL':
        return 'pc端导表';
      case 'OPEN_API':
        return 'OPEN_API';
      case 'AI':
        return '智能录单';
      default:
        break;
    }
  },
  payStatusFilter: function (status) {
    switch (status) {
      case 'INIT':
        return '待申请';
      case 'CHANNELAUDITED':
        return '网货审核';
      case 'CHANNELREFUSE':
        return '网货拒绝';
      case 'PAYING':
        return '财务审核';
      case 'REFUSE':
        return '财务拒绝';
      case 'SUCCESS':
        return '支付完成';
      case 'EXPIRED':
        return '已过期';
      default:
        break;
    }
  },
  formatEditTimeNew: function (time) {
    if (time) {
      const h = moment(time).format('HH');
      if (h < 12) {
        return `${moment(time).format('M月D日')}上午`;
      } else {
        return `${moment(time).format('M月D日')}下午`;
      }
    }
  },
  // 金额过滤
  formatMoney: function (money) {
    if (!money || money == 0) {
      money = 0;
    }
    const isMoney = money < 0;
    money = Math.abs(money);
    money = `${(money / 100).toFixed(2)}`;
    var l = money.split('.')[0].split('').reverse(),
      r = money.split('.')[1],
      t = '';
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
    }
    return `${isMoney ? '-' : ''}${t.split('').reverse().join('')}.${r}`;
  },

  toThousands: function (num) {
    num = `${(num / 100).toFixed(2)}`;
    let logo = ''; //用于记录是正值还是负值
    if (num < 0) {
      logo = '-';
      num = -num; //将负数转正,如果不转正，则下面获取它的length时，会由于有个负号，使得长度+1，最终加逗号位置出错
    }
    num = (num || 0).toString();
    let number = 0,
      floatNum = '',
      intNum = '';
    // 判断是否有小数位，有则截取小数点后的数字
    if (num.indexOf('.') > 0) {
      number = num.indexOf('.'); // 获取小数点出现的位置
      floatNum = num.substr(number); // 截取arr.substr(form, length)
      intNum = num.substring(0, number); // 截取arr.substring(start, end)
    } else {
      intNum = num;
    }
    const result = [];
    let counter = 0;
    intNum = intNum.split('');
    // 利用3的倍数，向数组插入','
    for (let i = intNum.length - 1; i >= 0; i--) {
      counter++;
      result.unshift(intNum[i]);
      if (!(counter % 3) && i != 0) {
        result.unshift(',');
      }
    }
    return logo + result.join('') + floatNum || '';
  },

  // km 转换
  formatMileage: function (mileage) {
    if (!mileage) {
      return;
    }
    const num = (mileage / 100000).toString();
    return num.substring(0, num.indexOf('.') + 3);
  },
  filterProperty: function (val) {
    return val === 'transfer' ? '外调' : '自有';
  },
  filterChannelName: id => {
    const channel = channelInfos.find(channel => channel.value === id) || {};
    return channel.label || '';
  },
  /**
   * @description: 显示结算单类型
   * @param {String}
   * @return {String}
   * @author: lijinpeng
   */
  filterSettlementTypes: val => {
    const settlement = settlementTypes.find(type => type.value === val) || {};
    return settlement.label || '';
  },

  // 增加测试企业展示
  filterTestCorp: val => {
    let name = '';
    // const testName = [
    //   '辽宁名远企业管理咨询有限公司',
    //   '北京考拉驿站网络科技有限公司',
    //   '江西天诚易通物流有限公司',
    // ];
    // if (testName.includes(val)) {
    //   name = `${val}(测试)`;
    // } else {
    name = val;
    // }
    return name;
  },
  //   载货长度带单位
  filterExtent: val => {
    let name = '';
    const testName = [
      '18.5',
      '17.5',
      '16',
      '15',
      '13.7',
      '13',
      '12.5',
      '11.7',
      '9.6',
      '8.7',
      '8.2',
      '7.7',
      '6.8',
      '6.2',
      '5',
      '4.2',
      '3.8',
      '2.7',
      '1.8',
      '1.6',
      '1.4',
    ];
    if (testName.includes(val)) {
      name = `${val} 米`;
    } else {
      name = val;
    }
    return name;
  },
  formatStatus(status) {
    switch (status) {
      case 1:
        return '未按约定从指定高速入口驶入';
      case 2:
        return '轨迹偏离';
      case 3:
        return '未按约定从指定高速出口驶出';
      default:
        return '轨迹偏离';
    }
  },
  filterBankCardNo: bankCardNo => {
    if (/\S{5}/.test(bankCardNo)) {
      return bankCardNo.replace(/\s/g, '').replace(/(.{4})/g, '$1 ');
    } else {
      return bankCardNo;
    }
  },
  filterDataPermission: function (status) {
    switch (status) {
      case 'GROUP':
        return '集团';
      case 'PROJECT':
        return '项目';
      case 'PERSONAL':
        return '个人';
      default:
        break;
    }
  },
  filterRoleStatus: function (status) {
    switch (status) {
      case 'SUPER_ADMIN':
        return '系统管理员';
      case 'SUPER_FINANCE':
        return '超级财务';
      case 'NORMAL_FINANCE':
        return '普通财务';
      case 'NORMAL':
        return '外调车调度';
      case 'NORMAL_ZY':
        return '自有车调度';
      default:
        break;
    }
  },
};

export default filters;
